( function( $, w ) {

    /**
     * Scope for handling the main functionality of the ETHZ website.
     */
    function ETHZ() {

        /**
         * Static utility functions.
         */
        var Utility = this.Utility = {

            /**
             * Tries to retrieve the given key from TYPO3.lang.
             *
             * @param {string} key The key to look for
             * @param {string} [fallback] The value to return, if the key wasn't found
             * @return {string} The TYPO3.lang value or the specified fallback, if the key wasn't found
             */
            translate: function( key, fallback ) {

                if ( typeof fallback !== 'string' ) {
                    fallback = '';
                }

                if (
                    typeof TYPO3 !== 'object'
                    || !( 'lang' in TYPO3
                    || typeof TYPO3.lang !== 'object' )
                ) {
                    return fallback;
                }

                return key in TYPO3.lang
                    ? TYPO3.lang[ key ]
                    : fallback;

            }

        };

        /**
         * Allows invoking of functions automatically as soon as the DOM is ready.
         */
        var AutoLoader = this.AutoLoader = new function() {

            /**
             * The queue holding functions to load.
             *
             * @type {object}
             */
            var queue = {};

            /**
             * Adds an function to the queue.
             *
             * @param {string} name The name of the key to set. Used to detect duplicates.
             * @param {function} fn The function to enqueue
             */
            this.register = function( name, fn ) {
                if( typeof fn !== 'function') {
                    throw new Error( 'Second argument of ETHZ.AutoLoader.register has to be of type \'function\', \''
                        + ( typeof fn ) + '\' given.' );
                }
                queue[ String( name ) ] = fn;
            };

            /**
             * Invokes all registered functions.
             */
            function load() {
                $.each( queue, function( name, fn ) {
                    fn();
                } );
            }

            $( document ).ready( load );

        };

        /**
         * DOM Pre-processing.
         */
        var PreProcessing = this.PreProcessing = new function() {

            /**
             * Main entry method.
             * Manipulates DOM.
             */
            function init() {
                $( 'body' ).addClass( 'javascript' );
            }

            AutoLoader.register( 'PreProcessing', init );

        };

        /**
         * Handles date picker instances.
         */
        var DatePicker = this.DatePicker = new function() {

            /**
             * Main entry point.
             * Registers date pickers.
             */
            function init() {
                $( '[data-component="datepicker"]' ).datepicker( {
                    showButtonPanel: true,
                    firstDay: 1,
                    currentText: Utility.translate( 'date.current', 'Today' ),
                    dateFormat: 'dd.mm.yy',
                    dayNamesMin: [
                        Utility.translate( 'date.day.min.7', 'Sunday' ),
                        Utility.translate( 'date.day.min.1', 'Monday' ),
                        Utility.translate( 'date.day.min.2', 'Tuesday' ),
                        Utility.translate( 'date.day.min.3', 'Wednesday' ),
                        Utility.translate( 'date.day.min.4', 'Thursday' ),
                        Utility.translate( 'date.day.min.5', 'Friday' ),
                        Utility.translate( 'date.day.min.6', 'Saturday' ),
                    ],
                    monthNames: [
                        Utility.translate( 'date.month.default.1', 'January' ),
                        Utility.translate( 'date.month.default.2', 'February' ),
                        Utility.translate( 'date.month.default.3', 'March' ),
                        Utility.translate( 'date.month.default.4', 'April' ),
                        Utility.translate( 'date.month.default.5', 'May' ),
                        Utility.translate( 'date.month.default.6', 'June' ),
                        Utility.translate( 'date.month.default.7', 'July' ),
                        Utility.translate( 'date.month.default.8', 'August' ),
                        Utility.translate( 'date.month.default.9', 'September' ),
                        Utility.translate( 'date.month.default.10', 'October' ),
                        Utility.translate( 'date.month.default.11', 'November' ),
                        Utility.translate( 'date.month.default.12', 'December' )
                    ],
                    onSelect: emitAfterDatePickerChanged
                } );
            }

            /**
             * Dispatches an event indicating a date picker value has changed.
             *
             * @param {string} date The selected date
             * @param {object} datePicker The date picker instance
             */
            function emitAfterDatePickerChanged( date, datePicker ) {
                $( this ).trigger( 'changed.ethz.datepicker', [ date, datePicker ] );
            }

            AutoLoader.register( 'DatePicker', init );

        };

        /**
         * Generic filter handler.
         */
        var Filter = this.Filter = new function() {

            /**
             * Toggle a filter.
             *
             * @param {string} filterType The type of the filter to toggle
             * @param {number|string} filterValue The value of the filter to toggle
             * @param {string} scope The scope where to toggle available filters, if any
             */
            this.toggle = function( filterType, filterValue, scope ) {

                    // Initialization
                if( typeof filterType !== 'string' ) {
                    throw new Error( 'First argument of ETHZ.Filter.apply has to be of type \'string\', \''
                        + ( typeof filterType ) + '\' given.' );
                }

                if( typeof filterValue !== 'number' && typeof filterValue !== 'string' ) {
                    throw new Error( 'Second argument of ETHZ.Filter.apply has to be either of type \'number\' or \'string\', \''
                        + ( typeof filterValue ) + '\' given.' );
                }

                if( typeof scope !== 'string' ) {
                    scope = 'body';
                }

                var anchors = $( '[data-filter-type="' + filterType + '"]', scope ),
                    triggers = anchors.filter( '[data-filter-value="' + filterValue + '"]' ),
                    enable = !triggers.hasClass( 'enabled' );

                    // Toggle CSS class
                if( enable ) {
                    triggers.removeClass( 'disabled' )
                        .addClass( 'enabled' )
                        .trigger( 'enable.ethz.filter' );
                    anchors.filter( ':not(.enabled)' )
                        .addClass('disabled');
                } else {
                    triggers.removeClass( 'enabled' )
                        .addClass( 'disabled' )
                        .trigger( 'disable.ethz.filter' );
                    if( anchors.filter( '.enabled' ).length < 1 ) {
                        anchors.removeClass( 'enabled disabled' );
                    }
                }

                apply( $( scope ) );

            };

            /**
             * Main entry method.
             * Registers events.
             */
            function init() {
                $( '[data-component="datepicker"][data-filter-type="filter-date"][data-target]' )
                    .on( 'changed.ethz.datepicker', setDate );
                $(window).on('hashchange', applySlug);
                applySlug();
            }

            /**
             * Sets the date to filter.
             *
             * @param {object} event Event object passed
             * @param {string} date The date to set
             */
            function setDate( event, date ) {

                var container = $( this ),
                    scope = $( container.data( 'target' ) ),
                    search = parseInt( date.split( '.' ).reverse().join( '' ) );

                container.attr( 'data-filter-value', search );

                apply( scope );

            }

            /**
             * Applies all filters within a specific scope.
             *
             * @param {object} scope jQuery object of the scope to apply filters on
             */
            function apply( scope ) {

                var triggers = scope.find( '[data-filter-type][data-filter-value]:not(.disabled)' ),
                    typeSelectors = [],
                    filters = {};

                triggers.each( function() {

                    var filter = $( this ),
                        filterType = filter.data( 'filter-type' );
                    
                    if( $.inArray( '[data-' + filterType + ']', typeSelectors ) < 0 ) {
                        typeSelectors.push( '[data-' + filterType + ']' );
                        filters[ filterType ] = {
                            operator: filter.data( 'filter-operator' ) || 'intersect',
                            values: []
                        };
                    }

                    filters[ filterType ].values.push( String( filter.attr( 'data-filter-value' ) ) );

                } );

                var targets = scope.find( typeSelectors.join( ',' ) );

                targets.removeClass( 'd-none' )
                    .filter(function() {
                        return isFiltered( this, filters );
                    })
                    .addClass( 'd-none' );

            }

            /**
             * Checks whether a specific node is filtered.
             *
             * @param {HTMLElement} node The node to check
             * @param {object} filters The folters to check
             * @return {boolean} TRUE if the node is filtered, otherwise FALSE
             */
            function isFiltered( node, filters ) {

                var item = $( node ),
                    isFiltered = false;

                $.each( filters, function( type ) {

                    var value = item.data( type );

                    if( typeof value === 'undefined' ) {
                        return true; // continue
                    }

                    switch( this.operator ) {
                        case 'lt':
                            if( parseInt( value ) < parseInt( this.values[ 0 ] ) ) {
                                isFiltered = true;
                                return false; // break
                            }
                            break;
                        case 'lte':
                            if( parseInt( value ) <= parseInt( this.values[ 0 ] ) ) {
                                isFiltered = true;
                                return false; // break
                            }
                            break;
                        default:
                            if(
                                this.values.length > 0
                                && $( String( value ).split( ',' ) ).filter( this.values ).length < 1
                            ) {
                                isFiltered = true;
                                return false; // break
                            }
                    }

                } );

                return isFiltered;

            }

            function applySlug() {
                if (window.location.hash.length < 2) {
                    return;
                }
                var slug = window.location.hash.substring(1),
                    selectors = $('.frame a[data-filter-type="event-types"][data-filter-slug="' + slug + '"][data-filter-value][data-target]');
                selectors.each(function () {
                    var anchor = $(this),
                        filterValue = anchor.data('filter-value'),
                        scope = anchor.data('target'),
                        pool = $('a[data-filter-type="event-types"]', scope);
                    pool.removeClass('enabled').addClass('disabled');
                    Filter.toggle('event-types', filterValue, scope);
                });
            }

            AutoLoader.register( 'Filter', init );

        };

    }

        // Export to global scope
    w.ETHZ = new ETHZ();

} )( jQuery, window );